import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { parsePhoneNumber } from 'react-phone-number-input'
import { CountryCodeType } from 'src/types/phoneinput'
import { ResponseDataBody } from 'src/types/websocket'

export type HomeDataType = ResponseDataBody.HomeInfo & {
  TempValue: {
    GPNumber: string
    CountryCode: { num: string | null; country: string | null }
    LockMsg: string | null
  }
}

const initialState: HomeDataType = {
  Name: '',
  Model: '',
  GPNumber: '',
  CountryCode: null,
  LockMsg: null,
  LastUpdateDT: 0,
  TempValue: {
    GPNumber: '',
    CountryCode: { num: null, country: null },
    LockMsg: null,
  },
}

const homePageSlice = createSlice({
  name: 'HomePage',
  initialState,
  reducers: {
    setHomeInfo(state, action: PayloadAction<ResponseDataBody.HomeInfo>) {
      const { Name, Model, GPNumber, CountryCode, LockMsg, LastUpdateDT } = action.payload
      state.Name = Name
      state.Model = Model
      state.GPNumber = GPNumber
      state.CountryCode = CountryCode
      state.LockMsg = LockMsg
      state.LastUpdateDT = LastUpdateDT
      state.TempValue = {
        GPNumber: GPNumber,
        CountryCode: {
          country: CountryCodeSwitch(CountryCode, GPNumber),
          num: CountryCode,
        },
        LockMsg: LockMsg,
      }
    },
    setTempLockMessage(state, action) {
      state.TempValue.LockMsg = action.payload
    },
    setTempGPNumber(state, action) {
      state.TempValue.GPNumber = action.payload
    },
    setTempCountryCode(state, action) {
      state.TempValue.CountryCode = action.payload
    },
  },
})

export const { setHomeInfo, setTempCountryCode, setTempGPNumber, setTempLockMessage } =
  homePageSlice.actions

export default homePageSlice.reducer

const CountryCodeSwitch = (CountryCode: null | string, GPNumber: string) => {
  // 라이브러리 내에 중복되는 국가 전화번호 처리
  switch (CountryCode) {
    // 기본, 미국, 캐나다
    case '':
    case '1':
      return 'US'
    // 러시아, 카자흐스탄
    case '7':
      return 'RU'
    // 이탈리아, 바티칸 시국
    case '39':
      return 'IT'
    //영국, 건지, 맨섬, 저지섬
    case '44':
      return 'GB'
    // 노르웨이, svalbard and jan mayen
    case '47':
      return 'NO'
    //호주
    case '61':
      return 'AU'
    // 모로코, 서사하라
    case '212':
      return 'MA'
    //레위니옹(프랑스), 마요트(프랑스)
    case '262':
      return 'YT'
    //세인트 헬레나 (?), 트리스탄다쿠냐
    case '290':
      return 'SH'
    //핀란드, 올란드 제도
    case '358':
      return 'FI'
    //과들루프, 생바르텔레미
    case '590':
      return 'GP'
    //네덜란드령 카리브 , 퀴라소
    case '599':
      return 'CW'
    default:
      return parsePhoneNumber(`+${CountryCode} ${GPNumber}`)?.country as CountryCodeType
  }
}
